import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import DailyForecast from "./DailyForecast";
import axios from "axios";
import "./Weather.css";

export default function Weather(props) {
    const [weatherData, setWeatherData] = useState({ ready: false });
    const [city, setCity] = useState(props.defaultCity);
    function handleResponse(response) {
        
        setWeatherData({
            ready: true,
            temperature: response.data.temperature.current,
            humidity: response.data.temperature.humidity,
            date: new Date(response.data.time * 1000),
            description: response.data.condition.description,
            iconUrl: `http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${response.data.condition.icon}.png`,
            wind: response.data.wind.speed,
            city: response.data.city,

        });

    }

    function search() {
        const apiKey = "06b0f64a63552tbee14aof0301449fb0";
        let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
        axios.get(apiUrl).then(handleResponse);
    }

    function handleSubmit(event) {
        event.preventDefault();
        search();
      }

      function handleCityChange(event) {
        setCity(event.target.value);
      }

    if (weatherData.ready) {
        return (
        <div className="Weather">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-9">
                        <input 
                        type="search" 
                        placeholder="Enter your city.." 
                        className="form-control" 
                        autofocus="on"
                        onChange={handleCityChange}
                        /> 

                    </div>
                    <div className="col-3">
                        <input 
                        type="submit" 
                        value="Search" 
                        className="btn btn-light w-100" />
                    </div>
                </div>
            </form>
            <WeatherInfo data={weatherData} />
            <DailyForecast data={weatherData} />
        </div>
    )
    } else {
        search();
        return "Loading...";
    }
}